import { Component, ViewChild, input } from '@angular/core';
import { CanLeaveGuardComponent } from '@pflegix/guard';
import { I18NextAdapterPipe } from '@pflegix/i18n';
import { DashboardLayoutComponent, DialogComponent, PanelComponent, PfxTemplateDirective } from '@pflegix/ui';
import { ConfirmationService } from 'primeng/api';
import { OrderUpdateComponent } from '../../../../../../feature/order-management/order-update';
import { OVERVIEW_VIEW_NAMESPACE } from './i18n/const/overview-view-namespace.const';
import { OVERVIEW_VIEW_TRANSLATION_DE } from './i18n/de/overview-view.translation.de';
import { OVERVIEW_VIEW_TRANSLATION_EN } from './i18n/en/overview-view-translation.en';

@Component({
  selector: 'pfx-overview-view',
  imports: [
    DialogComponent,
    DashboardLayoutComponent,
    PanelComponent,
    OrderUpdateComponent,
    PfxTemplateDirective,
    I18NextAdapterPipe,
  ],
  providers: [ConfirmationService],
  templateUrl: './overview-view.component.html',
  styleUrl: './overview-view.component.scss',
})
export class OverviewViewComponent extends CanLeaveGuardComponent {
  public orderId = input.required<string>();

  @ViewChild(OrderUpdateComponent) protected orderUpdateComponent!: OrderUpdateComponent;

  protected i18nNamespace = OVERVIEW_VIEW_NAMESPACE;

  constructor() {
    super();

    this.i18n.addTranslations({
      namespace: OVERVIEW_VIEW_NAMESPACE,
      de: OVERVIEW_VIEW_TRANSLATION_DE,
      en: OVERVIEW_VIEW_TRANSLATION_EN,
    });
  }

  public override canDeactivate(): boolean {
    return this.orderUpdateComponent.canDeactivate();
  }

  public resetUpdateForm(): void {
    this.orderUpdateComponent.resetForm();
  }
}
